<template>
    <console-content max-width="1280">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">배너목록</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <!-- <v-row align="center">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field label="label" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field label="label" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                    </v-row> -->
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.type" :items="typeItems" item-text="text" item-value="value" label="타입" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-6 px-1" align="end">
            <v-col cols="auto" class="py-0 subtitle-2">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="banners" :headers="bannersHeaders" hide-default-footer disable-pagination class="mt-3 mx-1 elevation-1">
            <!-- <template slot="item.no" slot-scope="{item}">
                <span>{{ (page - 1) * limit + +banners.indexOf(item) + 1 }}</span>
            </template> -->
            <v-layout slot="item.image" slot-scope="{item}" justify-center>
                <v-img :src="item.image" width="100" height="100"/>
            </v-layout>
            <v-layout slot="item.actions" slot-scope="{item}" justify-center>
                <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                <v-icon small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
            </v-layout>
            <template slot="item.createdAt" slot-scope="{item}">
                <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <v-btn fab fixed bottom right color="accent" @click="$router.push('/console/common/banners/create')"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                type: this.$route.query.type || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,

            summary: { totalCount: 0 },
            banners: [],
            bannersHeaders: [
                { text: "no", value: "no", align: "center", /* width: 10 */ },
                { text: "제목", value: "subject", align: "center", /* width: 10 */ },
                { text: "이미지", value: "image", align: "center", /* width: 10 */ },
                { text: "타입", value: "type", align: "center", /* width: 10 */ },
                { text: "생성일자", value: "createdAt", align: "center", /* width: 10 */ },
                { text: "actions", value: "actions", align: "center", /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제목", value: "subject" },
            ],

            typeItems: [
                { text: ":: 전체 ::", value: null },
                { text: "PC", value: "pc" },
                { text: "MOBILE", value: "mobile" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, banners } = await api.console.common.banners.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.banners = banners;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        edit(banner) {
            this.$router.push(`/console/common/banners/${banner._id}`)
        },
        async remove(banner) {
            if (confirm("해당 배너를 삭제하시겠습니까?")) {
                await api.console.common.banners.delete(banner);
                alert("배너가 삭제되었습니다");
                this.init()
            }
        }
    }
}
</script>